<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <button
            class="btn btn-success mr-1"
            @click="confirmdepositesettll"
            v-b-tooltip.hover
            :title="
              this.model.pinjamankey
                ? 'Prepaid Settlement'
                : 'Pilih salah satu yang akan di settlement dengan prepaid'
            "
            :disabled="!this.model.pinjamankey"
          >
            <i class="fa fa-play"></i> Prepaid Settlement
          </button>
          <button
            class="btn btn-primary mr-1"
            @click="showFilter = !showFilter"
          >
            <i class="fa fa-filter"></i> Filter
          </button>
          <b-button variant="primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="7">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 100px">No. Kontrak</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.nomor"
                  placeholder="No Kontrak"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 100px">CIF No. </label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.CustCode"
                  placeholder="CIF Number"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Debitur</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.customer"
                  placeholder="Customer"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <!-- <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Model Pinjaman</label>
                </b-input-group-prepend>
                <b-form-select
                  v-model="tblData.model_pinjaman"
                  :plain="true"
                  :options="modelkredit"
                ></b-form-select>
              </b-input-group>
            </b-col> -->
            <!-- <b-col lg="6"> -->
              <!-- <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 100px">No. Agreement</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.agreement"
                  placeholder="No Agreement"
                ></b-form-input>
              </b-input-group> -->
              <!-- <b-input-group>
                <b-input-group-prepend>
                  <label style="width:100px;">Collector</label>
                </b-input-group-prepend>
                <b-form-select v-model="tblData.collector_id" :plain="true" :options="collectors"></b-form-select>
              </b-input-group> -->
            <!-- </b-col> -->
          </b-row>
        </b-col>
        <b-col lg="5">
          <b-row>
            <b-col lg="12">
            <b-input-group>
            <!-- <b-input-group-prepend>
              <label>Days Over Due</label>
            </b-input-group-prepend>
            <my-number
              class="form-control text-right"
              separator=","
              v-model="tblData.dod1"
              :precision="0"
              style="min-width: 50px; max-width: 100px"
            ></my-number>
            <b-input-group-prepend>
              <span class="input-group-text">until</span>
            </b-input-group-prepend>
            <my-number
              class="form-control text-right"
              separator=","
              v-model="tblData.dod2"
              :precision="0"
              style="min-width: 50px; max-width: 100px"
            ></my-number> -->
            <b-input-group-prepend>
              <label>Last Payment</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
            <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>  
            <!-- <b-input-group-prepend>
              <span class="ml-2 pt-2">Collector&nbsp;</span>
            </b-input-group-prepend>
            <b-form-select
              v-model="tblData.collector_id"
              :plain="true"
              :options="collectors"
            ></b-form-select> -->
          </b-input-group>
          <!-- <b-input-group>
            <b-input-group-prepend>
              <label class="pt-2">Kolektabilitas</label>
            </b-input-group-prepend>
            <b-form-select
              v-model="tblData.collectability"
              :plain="true"
              :options="kolStatus"
            ></b-form-select>
            <b-input-group-prepend>
              <label class="px-2">Status Pinjaman</label>
            </b-input-group-prepend>
            <b-form-select
              v-model="tblData.status"
              :plain="true"
              :options="statuses"
            ></b-form-select>
          </b-input-group> -->
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-input-group>
            <!-- <b-input-group-prepend>
              <label>Status WO</label>
            </b-input-group-prepend>
            <b-form-select
              v-model="tblData.wo_status"
              :plain="true"
              :options="wostatus"
            ></b-form-select>
            <b-input-group-prepend>
              <span class="ml-2 pt-2">Source Project&nbsp;</span>
            </b-input-group-prepend>
            <b-form-select
              v-model="tblData.pjxkey"
              :plain="true"
              :options="sourceproject"
            ></b-form-select> -->
            <!-- <b-input-group-prepend>
              <label>Collector</label>
            </b-input-group-prepend>
            <b-form-select
              v-model="tblData.collector_id"
              :plain="true"
              :options="collectors"
            ></b-form-select> -->
            <b-input-group-append>
              <b-button
                variant="success"
                size="sm"
                @click="refresh()"
              >
                <i class="fa fa-refresh"></i> Apply Filter
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button
                variant="secondary"
                size="sm"
                class="ml-2"
                @click="clearFilter()"
                >Clear Filter</b-button
              >
            </b-input-group-append>
          </b-input-group>
          </b-col>
          </b-row>
        </b-col>
        <!-- <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend>
              <label>Tgl. Cair</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text">until</span>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
            <b-input-group-prepend> </b-input-group-prepend>
          </b-input-group>
        </b-col> -->
        <!-- <b-col offset="5" lg="7">   
        </b-col> -->
      </b-row>
      <b-card no-body class="mb-0">
        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          striped
          hover
          style="font-size: smaller"
          :items="data"
          :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit"
          :busy="isBusy"
          @row-clicked="rowClicked"
          show-empty
        >
          <template v-slot:cell(index)="data">{{((tblData.page-1)*tblData.limit) +(data.index + 1) }}</template>
          <template v-slot:cell(last_tglpaym)="data">
            {{ data.item.last_tglpaym | moment("DD/MM/YY") }}</template
          >
          <template v-slot:cell(tgl_kontrak)="data">
            {{ data.item.tgl_kontrak | moment("DD/MM/YY") }}</template
          >
          <template v-slot:cell(plafon)="data">{{
            data.item.plafon | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(principal)="data">{{
            data.item.principal | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(installment_amount)="data">{{
            data.item.installment_amount | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(denda_tarifhri)="data">{{
            data.item.denda_tarifhri | numFormat("0,0.000")
          }}</template>
          <template v-slot:cell(bungaod_tarifbln)="data">{{
            data.item.bungaod_tarifbln | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(bunga_tarifthn)="data">{{
            data.item.bunga_tarifthn | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(tenor)="data">{{
            data.item.tenor | numFormat
          }}</template>
          <template v-slot:cell(startdate)="data">{{
            data.item.startdate | moment("DD/MM/YY")
          }}</template>
          <template v-slot:cell(duedate)="data">{{
            data.item.duedate | moment("DD/MM/YY")
          }}</template>
          <template v-slot:cell(sum_pbb_amt)="data">{{
            data.item.sum_pbb_amt | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(sum_pbb_sttl)="data">{{
            data.item.sum_pbb_sttl | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(CONTRACT_PREPAID_AMT)="data">
            {{ data.item.CONTRACT_PREPAID_AMT < 1 ? 0 : data.item.CONTRACT_PREPAID_AMT | numFormat("0,0.00") }}
          </template>
          <!-- <template v-slot:cell(collectability)="data">
            {{ data.item.collectability }}
            <span v-if="data.item.npf_stop_accrue" class="bg-danger p-1"
              >Stop Accrued</span
            >
            <span v-else class="bg-success p-1">Accrued </span>
          </template> -->
          <template v-slot:cell(npf_stop_accrue)="data">
            <span v-if="data.item.npf_stop_accrue" class="bg-danger p-1"
              >Stop Accrued</span
            >
            <span v-else class="bg-success p-1">Accrued </span>
          </template>
          <template v-slot:cell(wo_status)="data">
            <span v-if="data.item.wo_status">ON</span>
            <span v-else>OFF</span>
          </template>

          <!-- <template v-slot:cell(collectability)="data">
          {{
          data.item.collectability == 'kol-1'?
          "1":data.item.collectability == 'kol-2'?
          "2":data.item.collectability == 'kol-3'?
          "3":data.item.collectability == 'kol-4'?
          "4":data.item.collectability == 'kol-5'?
          "5":data.item.collectability == 'WO'?
          "WO":"" }}
        </template> -->

          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
        </b-table>
      </b-card>

      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top: 0 !important">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25]"
                  :plain="true"
                  v-model="tblData.limit"
                  size="sm"
                  style="width: 80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      ref="modal-confirm-settlement"
      v-model="confirmdepositeShow"
      size="xl"
      title="Data Angsuran"
      :key="model.pinjamankey"
      :centered="true"
    >
      <b-card>
        <b-row>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend><label>CIF</label></b-input-group-prepend>
              <b-form-input v-model="model.CustCode" disabled></b-form-input>
            </b-input-group>
          </b-col>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend
                ><label>Nama Debitur</label></b-input-group-prepend
              >
              <b-form-input v-model="model.CustName" disabled></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend
                ><label>No Kontrak</label></b-input-group-prepend
              >
              <b-form-input
                v-model="model.no_kontrak"
                disabled
              ></b-form-input>
            </b-input-group>
          </b-col>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend
                ><label>Angsuran <br> Berikutnya</label></b-input-group-prepend
              >
              <b-form-input
                v-model="model.tunggakan_installment"
                disabled
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend
                ><label>Tgl. Jth Tempo</label></b-input-group-prepend
              >
              <b-form-input
                v-model="frmData.tgl_jttempo"
                disabled
              ></b-form-input>
            </b-input-group>
          </b-col>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend
                ><label>Prepaid un-settled</label></b-input-group-prepend
              >
              <my-number
                class="form-control text-right"
                v-model="model.pbb_ost"
                :precision="2"
                :disabled="true"
              ></my-number>
            </b-input-group>
          </b-col>
        </b-row>
        <hr />
        <b-table
          bordered
          responsive
          striped
          sticky-header
          :fields="tblFieldsPinjaman"
          hover
          :items="frmData"
        >
          <template #thead-top="data">
            <b-tr>
              <b-th colspan="5"><span class="sr-only"></span></b-th>
              <b-th variant="danger" colspan="3" class="text-center"
                >Settlement</b-th
              >
              <b-th variant="primary" class="text-center">Outstand</b-th>
            </b-tr>
          </template>
          <template #head(angsuran_ke)="data">
            <span><i class="fa fa-check-square-o" aria-hidden="true"></i></span>
          </template>
          <template v-slot:cell(angsuran_ke)="data">
            <div class="float-left">
              <b-form-checkbox
              @change="onselectangsuran($event,data.item)"
            >
            </b-form-checkbox>
            </div>
            <div class="float-right">
               {{ data.item.angsuran_ke }}
            </div>
          </template>
          <template v-slot:cell(angsuran)="data">
            <span class="float-left">{{ data.item.matauang }}</span>
            <span class="float-right">{{
              data.item.angsuran | numFormat("0,0.00")
            }}</span>
          </template>
          <template v-slot:cell(nilai_pokok)="data">
            <span class="float-left">{{ data.item.matauang }}</span>
            <span>{{ data.item.nilai_pokok | numFormat("0,0.00") }}</span>
          </template>
          <template v-slot:cell(nilai_bunga)="data">
            <span class="float-left">{{ data.item.matauang }}</span>
            <span>{{ data.item.nilai_bunga | numFormat("0,0.00") }}</span>
          </template>
          <template v-slot:cell(akum_denda)="data">
            <span class="float-left">{{ data.item.matauang }}</span>
            <span>{{ data.item.akum_denda | numFormat("0,0.00") }}</span>
          </template>
          <template v-slot:cell(settle_pokok)="data">
            <span class="float-left">{{ data.item.matauang }}</span>
            <span>{{ data.item.settle_pokok | numFormat("0,0.00") }}</span>
          </template>
          <template v-slot:cell(settle_bunga)="data">
            <span class="float-left">{{ data.item.matauang }}</span>
            <span>{{ data.item.settle_bunga | numFormat("0,0.00") }}</span>
          </template>
          <template v-slot:cell(settle_denda)="data">
            <span class="float-left">{{ data.item.matauang }}</span>
            <span>{{ data.item.settle_denda | numFormat("0,0.00") }}</span>
          </template>
          <template v-slot:cell(total_os)="data">
            <span class="float-left">{{ data.item.matauang }}</span>
            <span>{{ data.item.total_os | numFormat("0,0.00") }}</span>
          </template>
        </b-table>

        <b-row>
          <b-col offset="6" lg="6">
            <b-input-group>
              <b-input-group-prepend
                ><label>Total Settlement</label></b-input-group-prepend
              >
              <b-input-group-prepend
                ><span class="input-group-text" style="width: 70px">{{
                  subtotal.matauang
                }}</span></b-input-group-prepend
              >
              <my-number
                class="form-control text-right"
                v-model="subtotal.total_os"
                :precision="2"
                :disabled="true"
              ></my-number>
            </b-input-group>
          </b-col>
        </b-row>
      </b-card>
      <template #modal-footer>
        <div class="w-100 text-center">
          <b-button variant="primary" @click="handleConfirm" class="mr-2">
            Confirm
          </b-button>
          <b-button variant="warning" @click="resetModal"> Cancel </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import myNumber from "../../components/my-number";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import pinjaman from "../../apis/pinjamanpayment";
import installment from "../../apis/installmentkredit";
import arsettl from "../../apis/arsettlement";
import project from "../../apis/project";
import crud from "../../apis/crud";

toastr.init();
export default {
  components: { myNumber, Loading },
  data() {
    return {
      showFilter: false,
      isBusy: false,
      confirmdepositeShow: false,
      model: {},
      frmData: {},
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "no_kontrak",
        sortDesc: false,
        model_pinjaman: "",
        customer: "",
        nomor: "",
        CustCode: "",
        tgl1: "",
        tgl2: "",
        collector_id: "",
        collectability: "",
        sourceproject: this.$store.state.user.compcode || "",
        status: "",
        wo_status: "",
      },
      collectors: [{ value: "", text: "--- ALL ---" }],
      modelkredit: [
        { value: "", text: "--- ALL ---" },
        { value: "PAB", text: "Angsuran Bulanan" },
        { value: "PRK", text: "Rekening Koran" },
      ],
      kolStatus: [
        { value: "", text: "--- ALL ---" },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
      ],
      statuses: [
        { value: "", text: "--- ALL ---" },
        { value: "secure", text: "Perform(Secure)" },
        { value: "unsecure", text: "Non Perform" },
      ],
      sourceproject: [{ value: "", text: "--- ALL ---" }],
      wostatus: dropdown.woStatus,
      selectedloan:[],
      subtotal:{
        matauang:'',
        total_os:0
      }
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "#",
          thStyle: "width:100px",
          sortable: true,
        },
        {
          key: "no_kontrak",
          label: "No. Kontrak",
          thStyle: "width:140px",
          sortable: true,
        },
        {
          key: "CustCode",
          label: "CIF",
          thClass: "text-center",
          thStyle: "min-width:150px",
          sortable: true,
        },
        {
          key: "CustName",
          label: "Debitur Name",
          thClass: "text-center",
          thStyle: "min-width:150px",
          sortable: true,
        },
        {
          key: "last_tglpaym",
          label: "Last Payment",
          thClass: "text-center",
          thStyle: "min-width:150px",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "sum_pbb_amt",
          label: "Prepaid Received",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "sum_pbb_sttl",
          label: "Prepaid Settled",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "CONTRACT_PREPAID_AMT",
          label: "Prepaid \nUn-settled",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "tunggakan_installment",
          label: "Jml Tunggakan \nInstallment",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
      ];
      return fields;
    },
    tblFieldsPinjaman() {
      const fields = [
        {
          key: "angsuran_ke",
          label: "Angsuran Ke",
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "angsuran",
          label: "Angsuran",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "nilai_pokok",
          label: "Pokok",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "nilai_bunga",
          label: "Bunga",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "akum_denda",
          label: "Denda",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "settle_pokok",
          label: "Pokok",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "settle_bunga",
          label: "Bunga",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "settle_denda",
          label: "Denda",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "total_os",
          label: "Total",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },
  async created() {
    // this.isBusy = true;
    // this.data();
    const collSet = {
      tablename: "vwcollector",
      // page: 1,
      // limit: 20,
      // total: 0,
    };
    const collector = await crud.list(collSet);
    collector.map((dt) => {
      this.collectors.push({ value: dt.collector_id, text: dt.crewname });
    });

    const projectDt = await project.listbyuser();
    this.sourceproject = projectDt.reduce(
      (arr = [{ value: "", text: "--- ALL ---" }], item, index) => {
        arr.push({
          value: item.pjxkey,
          text: item.pjxname,
        });
        return arr;
      },
      [{ value: "", text: "--- ALL ---" }]
    );

    this.tblData.pjxkey =
      this.tblData.pjxkey ||
      (this.sourceproject.length > 0 ? this.sourceproject[0].value : "");
  },
  methods: {
    async exportDtl() {
      if (this.model.pinjamankey) {
        try {
          await pinjaman.exportDtlxls(this.model.pinjamankey);
        } catch (error) {
          this.isBusy = false;
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      } else {
        toastr.warn("Please select a row that want to export detail");
      }
    },

    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      if (record.isReturn === 1) {
        this.disabledRetur = true;
      } else {
        this.disabledRetur = false;
      }

      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    data: async function (ctx) {
      try {
        const list = await pinjaman.pinjamanPrepaidWithInstallment(
          this.tblData
        );
        //console.log("#list: ", list);
        this.isBusy = false;
        return list;
      } catch (error) {
        console.log("error : ", error);
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async refresh() {
      try {
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData.customer = "";
      this.tblData.nomor = "";
      this.tblData.CustCode = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.collectability = "";
      this.tblData.sourceproject = "";
      this.tblData.collector_id = "";
      this.tblData.model_pinjaman = "";
      this.tblData.wo_status = "";
      this.refresh();
    },
    async exportxls() {
      try {
        //console.log("#this.tblData: ", this.tblData);
        this.isBusy = true;
        await pinjaman.exportxlsPrepaid(this.tblData);
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    onselectangsuran(event,data){
      let selectedloan = this.selectedloan;
      let idx = selectedloan.findIndex(x=>x==data.angsurankey);
      this.subtotal.matauang = data.matauang;
      if(idx<0){
        if(this.model.pbb_ost < (this.subtotal.total_os +data.total_os)){
          toastr.error("Prepaid tidak mencukupi", "ERROR MESSAGE", 10000);
          return ;
        }
        selectedloan.push(data.angsurankey)
        this.subtotal.total_os += data.total_os;
      }else{
        selectedloan.splice(idx,1) 
        this.subtotal.total_os -= data.total_os;
      }
      
      this.selectedloan = selectedloan;
    },
    async confirmdepositesettll() {
      try {
        const dtSet = await installment.getangsuranOSDue(this.model);
        dtSet.map((item,index)=>{
          dtSet[index].total_os = item.outstand_pokok+item.outstand_bunga + item.outstand_denda;
        });
        this.frmData = dtSet

        // this.frmData.total_os =
        //   this.frmData.outstand_bunga + this.frmData.outstand_pokok;
        // this.frmData.tgl_jttempo = moment(this.frmData.tgl_jttempo).format(
        //   "DD-MMM-YYYY"
        // );
        this.subtotal.total_os=0;
        this.subtotal.matauang='';
        this.confirmdepositeShow = true;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async handleConfirm() {
      try {
        if(this.selectedloan.length==0){
          toastr.info("Pilih angsuran yang akan di-settle", "INFO", 5000);
          return;
        }
        await arsettl.prepaidsettlauto({pinjamankey:this.model.pinjamankey,'angsurankeys':this.selectedloan});
        this.confirmdepositeShow = false;
        toastr.success("Prepaid settlement berhasil", "SUCCESS", 5000);
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    resetModal() {
      this.frmData = {};
      this.confirmdepositeShow = false;
    },
    close() {
      router.push("home");
    },
  },
};
</script>